var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-dialog',{attrs:{"visible":_vm.showLoginPanel,"width":"40%"},on:{"update:visible":function($event){_vm.showLoginPanel=$event}}},[_c('wx-qr-code-login-panel',{attrs:{"visiable":_vm.showLoginPanel},on:{"error":_vm.onLoginError,"success":_vm.onLoginSuccess}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }